import { useEffect } from 'react';

type TapResearchNotEligiblePageProps = {
  redirectUrl?: string | null;
};

const MIN_DISPLAY_MS = 5000;

export function TapResearchNotEligiblePage({
  redirectUrl,
}: TapResearchNotEligiblePageProps) {
  useEffect(() => {
    if (!redirectUrl) return;
    const timer = setTimeout(() => {
      window.location.href = redirectUrl;
    }, MIN_DISPLAY_MS);
    return () => clearTimeout(timer);
  }, [redirectUrl]);

  return (
    <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[440px] w-full text-center">
        <div className="warn-ring mx-auto mb-7">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-[30px] h-[30px]"
          >
            <path d="M12 9v4" />
            <path d="M12 16.5h.01" />
            <path d="M10.3 3.9 1.9 18a2 2 0 0 0 1.7 3h16.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
          </svg>
        </div>
        <div className="text-[13px] font-semibold uppercase tracking-[0.18em] text-primary mb-3">
          Account checked
        </div>
        <h2 className="font-display text-[28px] sm:text-[32px] font-bold text-ink tracking-[-0.02em] leading-[1.2] mb-2">
          Not eligible for this study
        </h2>
        <p className="text-[16px] text-ink-muted leading-[1.65] max-w-[440px] mx-auto mb-2">
          We couldn't find enough Amazon purchase history on this account.
          Redirecting you back...
        </p>
      </div>
    </div>
  );
}
